export const HOME = {
  emergentLink: "home-emergent-link",
  bookNowHero: "hero-book-now-btn",
  browsePharmacy: "hero-pharmacy-btn",
};

export const NAV = {
  logo: "nav-logo",
  login: "nav-login-btn",
  logout: "nav-logout-btn",
  langToggle: "nav-lang-toggle",
  dashboard: "nav-dashboard-btn",
  admin: "nav-admin-btn",
  mobileMenu: "nav-mobile-menu-btn",
};

export const SERVICE = {
  card: (k) => `service-card-${k}`,
  bookBtn: (k) => `service-book-${k}`,
};

export const BOOK = {
  testSelect: "book-test-select",
  doctorSelect: "book-doctor-select",
  hospitalSelect: "book-hospital-select",
  departmentSelect: "book-department-select",
  roomSelect: "book-room-select",
  dateInput: "book-date-input",
  slotBtn: (t) => `book-slot-${t}`,
  patientName: "book-patient-name",
  patientAge: "book-patient-age",
  patientGender: "book-patient-gender",
  patientPhone: "book-patient-phone",
  patientEmail: "book-patient-email",
  proceed: "book-proceed-btn",
  pay: "book-pay-btn",
  confirmMockPay: "book-mock-pay-confirm",
};

export const PHARMACY = {
  search: "pharmacy-search",
  categorySelect: "pharmacy-category-select",
  addToCart: (id) => `pharmacy-add-${id}`,
  cartBtn: "pharmacy-cart-btn",
  checkout: "pharmacy-checkout-btn",
  address: "pharmacy-address",
  phone: "pharmacy-phone",
  placeOrder: "pharmacy-place-order-btn",
};

export const DASH = {
  tabBookings: "dash-tab-bookings",
  tabOrders: "dash-tab-orders",
  bookingRow: (id) => `dash-booking-${id}`,
  downloadReceipt: (id) => `dash-receipt-${id}`,
};

export const ADMIN = {
  statUsers: "admin-stat-users",
  statBookings: "admin-stat-bookings",
  statRevenue: "admin-stat-revenue",
  tabBookings: "admin-tab-bookings",
  tabUsers: "admin-tab-users",
  tabDoctors: "admin-tab-doctors",
  tabPharmacy: "admin-tab-pharmacy",
  addDoctorBtn: "admin-add-doctor-btn",
};
